var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useCallback, useMemo, useState } from 'react';
import debounce from 'lodash.debounce';
import { AutoCompleteTextarea } from '../AutoCompleteTextarea';
import { CommandItem } from '../CommandItem/CommandItem';
import { EmoticonItem } from '../EmoticonItem/EmoticonItem';
import { LoadingIndicator } from '../Loading/LoadingIndicator';
import { UserItem } from '../UserItem/UserItem';
import { useChannelContext } from '../../context/ChannelContext';
import { useChatContext } from '../../context/ChatContext';
var UnMemoizedChatAutoComplete = function (props) {
    var _a, _b;
    var additionalTextareaProps = props.additionalTextareaProps, commands = props.commands, disabled = props.disabled, disableMentions = props.disableMentions, grow = props.grow, handleSubmit = props.handleSubmit, innerRef = props.innerRef, maxRows = props.maxRows, _c = props.mentionAllAppUsers, mentionAllAppUsers = _c === void 0 ? false : _c, _d = props.mentionQueryParams, mentionQueryParams = _d === void 0 ? {} : _d, onChange = props.onChange, onFocus = props.onFocus, onPaste = props.onPaste, onSelectItem = props.onSelectItem, placeholder = props.placeholder, _e = props.rows, rows = _e === void 0 ? 3 : _e, SuggestionItem = props.SuggestionItem, SuggestionList = props.SuggestionList, triggers = props.triggers, value = props.value;
    var _f = useChannelContext(), channel = _f.channel, emojiConfig = _f.emojiConfig;
    var _g = useChatContext(), client = _g.client, mutes = _g.mutes;
    var _h = useState(false), searching = _h[0], setSearching = _h[1];
    var members = (_a = channel === null || channel === void 0 ? void 0 : channel.state) === null || _a === void 0 ? void 0 : _a.members;
    var watchers = (_b = channel === null || channel === void 0 ? void 0 : channel.state) === null || _b === void 0 ? void 0 : _b.watchers;
    var _j = emojiConfig || {}, emojiData = _j.emojiData, EmojiIndex = _j.EmojiIndex;
    var emojiIndex = useMemo(function () {
        if (EmojiIndex) {
            // @ts-expect-error type here isn't registering the constructor type
            return new EmojiIndex(emojiData);
        }
        return null;
    }, [emojiData, EmojiIndex]);
    var emojiReplace = function (word) {
        var found = (emojiIndex === null || emojiIndex === void 0 ? void 0 : emojiIndex.search(word)) || [];
        var emoji = found
            .filter(Boolean)
            .slice(0, 10)
            .find(function (_a) {
            var emoticons = _a.emoticons;
            return !!(emoticons === null || emoticons === void 0 ? void 0 : emoticons.includes(word));
        });
        if (!emoji || !('native' in emoji))
            return null;
        return emoji.native;
    };
    var getMembersAndWatchers = useCallback(function () {
        var memberUsers = members ? Object.values(members).map(function (_a) {
            var user = _a.user;
            return user;
        }) : [];
        var watcherUsers = watchers ? Object.values(watchers) : [];
        var users = __spreadArray(__spreadArray([], memberUsers), watcherUsers);
        // make sure we don't list users twice
        var uniqueUsers = {};
        users.forEach(function (user) {
            if (user && !uniqueUsers[user.id]) {
                uniqueUsers[user.id] = user;
            }
        });
        return Object.values(uniqueUsers);
    }, [members, watchers]);
    var queryMembersDebounced = useCallback(debounce(function (query, onReady) { return __awaiter(void 0, void 0, void 0, function () {
        var response, users, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, channel.queryMembers({
                            name: { $autocomplete: query },
                        })];
                case 1:
                    response = _a.sent();
                    users = response.members.map(function (member) { return member.user; });
                    if (onReady && users.length) {
                        onReady(users);
                    }
                    else {
                        onReady([]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log({ error: error_1 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, 200), [channel]);
    var queryUsers = function (query, onReady) { return __awaiter(void 0, void 0, void 0, function () {
        var users, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!query || searching)
                        return [2 /*return*/];
                    setSearching(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.queryUsers(__assign({ $or: [{ id: { $autocomplete: query } }, { name: { $autocomplete: query } }], id: { $ne: client.userID } }, mentionQueryParams.filters), __assign({ id: 1 }, mentionQueryParams.sort), __assign({ limit: 10 }, mentionQueryParams.options))];
                case 2:
                    users = (_a.sent()).users;
                    if (onReady && users.length) {
                        onReady(users);
                    }
                    else {
                        onReady([]);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.log({ error: error_2 });
                    return [3 /*break*/, 4];
                case 4:
                    setSearching(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var queryUsersDebounced = debounce(queryUsers, 200);
    /**
     * dataProvider accepts `onReady` function, which will executed once the data is ready.
     * Another approach would have been to simply return the data from dataProvider and let the
     * component await for it and then execute the required logic. We are going for callback instead
     * of async-await since we have debounce function in dataProvider. Which will delay the execution
     * of api call on trailing end of debounce (lets call it a1) but will return with result of
     * previous call without waiting for a1. So in this case, we want to execute onReady, when trailing
     * end of debounce executes.
     */
    var getTriggers = useCallback(function () {
        return triggers ||
            {
                '/': {
                    component: CommandItem,
                    dataProvider: function (query, text, onReady) {
                        if (text.indexOf('/') !== 0 || !commands) {
                            return [];
                        }
                        var selectedCommands = commands.filter(function (command) { var _a; return ((_a = command.name) === null || _a === void 0 ? void 0 : _a.indexOf(query)) !== -1; });
                        // sort alphabetically unless the you're matching the first char
                        selectedCommands.sort(function (a, b) {
                            var _a, _b;
                            var nameA = (_a = a.name) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                            var nameB = (_b = b.name) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                            if ((nameA === null || nameA === void 0 ? void 0 : nameA.indexOf(query)) === 0) {
                                nameA = "0" + nameA;
                            }
                            if ((nameB === null || nameB === void 0 ? void 0 : nameB.indexOf(query)) === 0) {
                                nameB = "0" + nameB;
                            }
                            // Should confirm possible null / undefined when TS is fully implemented
                            if (nameA != null && nameB != null) {
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                            }
                            return 0;
                        });
                        var result = selectedCommands.slice(0, 10);
                        if (onReady)
                            onReady(result, query);
                        return result;
                    },
                    output: function (entity) { return ({
                        caretPosition: 'next',
                        key: entity.name,
                        text: "/" + entity.name,
                    }); },
                },
                ':': {
                    component: EmoticonItem,
                    dataProvider: function (query, _, onReady) {
                        if (query.length === 0 || query.charAt(0).match(/[^a-zA-Z0-9+-]/)) {
                            return [];
                        }
                        var emojis = (emojiIndex === null || emojiIndex === void 0 ? void 0 : emojiIndex.search(query)) || [];
                        // emojiIndex.search sometimes returns undefined values, so filter those out first
                        var result = emojis.filter(Boolean).slice(0, 10);
                        if (onReady)
                            onReady(result, query);
                        return result;
                    },
                    output: function (entity) { return ({
                        caretPosition: 'next',
                        key: entity.id,
                        text: "" + ('native' in entity ? entity.native : ''),
                    }); },
                },
                '@': {
                    callback: function (item) { return onSelectItem && onSelectItem(item); },
                    component: UserItem,
                    dataProvider: function (query, _, onReady) {
                        if (mentionAllAppUsers) {
                            return queryUsersDebounced(query, function (data) {
                                if (onReady)
                                    onReady(data, query);
                            });
                        }
                        /**
                         * By default, we return maximum 100 members via queryChannels api call.
                         * Thus it is safe to assume, that if number of members in channel.state is < 100,
                         * then all the members are already available on client side and we don't need to
                         * make any api call to queryMembers endpoint.
                         */
                        if (!query || Object.values(members || {}).length < 100) {
                            var users = getMembersAndWatchers();
                            var matchingUsers = users.filter(function (user) {
                                if (user.id === client.userID)
                                    return false;
                                if (!query)
                                    return true;
                                if (user.name !== undefined &&
                                    user.name.toLowerCase().includes(query.toLowerCase())) {
                                    return true;
                                }
                                return user.id.toLowerCase().includes(query.toLowerCase());
                            });
                            var data = matchingUsers.slice(0, 10);
                            if (onReady)
                                onReady(data, query);
                            return data;
                        }
                        return queryMembersDebounced(query, function (data) {
                            if (onReady)
                                onReady(data, query);
                        });
                    },
                    output: function (entity) { return ({
                        caretPosition: 'next',
                        key: entity.id,
                        text: "@" + (entity.name || entity.id),
                    }); },
                },
            };
    }, [
        commands,
        getMembersAndWatchers,
        members,
        onSelectItem,
        queryMembersDebounced,
        triggers,
        emojiIndex,
    ]);
    var updateInnerRef = useCallback(function (ref) {
        if (innerRef) {
            innerRef.current = ref;
        }
    }, [innerRef]);
    return (React.createElement(AutoCompleteTextarea, { additionalTextareaProps: additionalTextareaProps, className: 'str-chat__textarea__textarea', containerClassName: 'str-chat__textarea', disabled: disabled, disableMentions: disableMentions, dropdownClassName: 'str-chat__emojisearch', grow: grow, handleSubmit: handleSubmit, innerRef: updateInnerRef, itemClassName: 'str-chat__emojisearch__item', listClassName: 'str-chat__emojisearch__list', loadingComponent: LoadingIndicator, maxRows: maxRows, minChar: 0, mutes: mutes, onChange: onChange, onFocus: onFocus, onPaste: onPaste, placeholder: placeholder, replaceWord: emojiReplace, rows: rows, SuggestionItem: SuggestionItem, SuggestionList: SuggestionList, trigger: getTriggers(), value: value }));
};
export var ChatAutoComplete = React.memo(UnMemoizedChatAutoComplete);
